import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, orderByDsc } from './format'


export function newFacture(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_FACTURE_START", payload: "" })
            console.log("new Facture START", {data})
            const res = await axios.post('/factures/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_FACTURE_ERROR", dispatch) ){                
				dispatch({ type: "NEW_FACTURE", payload: res.data })
				dispatch({ type: "CREATE_FACTURE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new facture ", err);
            dispatch({
                type: "CREATE_FACTURE_ERROR",
                payload: err
            })
        }
    }
}

export function fetchFactures() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_FACTURES_START", payload: "" })
            
            console.log("fetch Facture START")
            const res = await axios.get('/factures/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_FACTURES_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_FACTURES",
                    payload: formatList(orderByDsc(res.data, "facture_creation_date"), "facture_id")
                })
                dispatch({ type: "FETCH_FACTURES_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get factures list ", err);
            dispatch({ type: "FETCH_FACTURES_ERROR", payload: err })
        }
    }
}
export function fetchFacturePayments(facture_id) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_FACTURE_PAYMENTS_START", payload: "" })
            
            console.log("fetch Facture START")
            const res = await axios.post('/factures/get/payments/list', {facture_id})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_FACTURE_PAYMENTS_ERROR", dispatch) ){ 
                dispatch({
                    type: "UPDATE_FACTURE_PAYMENTS",
                    payload: {list: res.data, facture_id}
                })
                dispatch({ type: "FETCH_FACTURE_PAYMENTS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get factures list ", err);
            dispatch({ type: "FETCH_FACTURE_PAYMENTS_ERROR", payload: err })
        }
    }
}


export function updateFacture(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_FACTURE_START", payload: "" })
            
            console.log("update Facture START")
            const res = await axios.post("/factures/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_FACTURE_ERROR", dispatch) ){  
                
				dispatch({
                    type: "UPDATE_FACTURE",
                    payload: data
                })
				dispatch({ type: "UPDATE_FACTURE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update facture ", err);
            dispatch({
                type: "UPDATE_FACTURE_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteFacture(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_FACTURE_START", payload: "" })

            console.log("delete facture START")
            const res = await axios.post("/factures/delete", {data: data.facture_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_FACTURE_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_FACTURE",
                    payload: data,
                })
                dispatch({ type: "DELETE_FACTURE_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete facture ", err);
            dispatch({
                type: "DELETE_FACTURE_ERROR",
                payload: err
            })
        }
    }
}



